export default "__VITE_ASSET__4844f1c2__"